import { getToken } from '@luminovo/auth';
import { resolveBase } from '@luminovo/http-client';
import { DefaultChatTransport, type UIMessage } from 'ai';

/** The auth-proxy derives `validated-token` from the bearer; a header the browser sent would be spoofable. */
export function createAgentChatTransport(tenant: string): DefaultChatTransport<UIMessage> {
    const gateway = resolveBase('gateway');
    return new DefaultChatTransport({
        api: `${gateway}/gateway/llm/agent`,
        // A function, so each message carries the current token: `useChat` keeps the transport it got first.
        headers: () => {
            const headers: Record<string, string> = { Authorization: `Bearer ${getToken()}` };
            // GATEWAY_HOST=http://localhost:3001 has no proxy in front, so the header comes from the real tenant.
            if (gateway.includes('localhost')) {
                headers['validated-token'] = btoa(JSON.stringify({ tenant }));
            }
            return headers;
        },
    });
}
